class MainProductOptions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', this.handleOptionChange.bind(this));
  }

  handleOptionChange(event) {
    const selectedOption = event.target.value;
    const selectedValueTextEl = event.target.closest('fieldset').querySelector('[data-selected-value]');
    if (selectedValueTextEl) {
      selectedValueTextEl.textContent = selectedOption;
    }
    this.updateOptions();
    this.updateCurrentVariant();
    this.updateVariantStatuses();
    this.updateURL();
    this.dispatchEvent(new CustomEvent('variant-change', { detail: this.currentVariant }));
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateCurrentVariant() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantStatuses() {
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    
    // Process all option groups
    inputWrappers.forEach((option, index) => {
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      
      // Get all currently selected options from other option groups
      const selectedOptions = [];
      for (let i = 0; i < inputWrappers.length; i++) {
        if (i !== index) { // Skip current option group
          const selectedInput = inputWrappers[i].querySelector(':checked');
          if (selectedInput) {
            selectedOptions.push({ index: i, value: selectedInput.value });
          }
        }
      }
      
      // Find all variants that match the currently selected options from other groups
      const matchingVariants = this.variantData.filter((variant) => {
        return selectedOptions.every((selectedOption) => {
          return variant[`option${selectedOption.index + 1}`] === selectedOption.value;
        });
      });
      
      // Get all available option values for this option group
      // Prefer the options array (robust for single-option products); fallback to optionN key
      const availableOptionValues = [
        ...new Set(
          matchingVariants.map((variant) => {
            if (Array.isArray(variant.options)) {
              return variant.options[index];
            }
            return variant[`option${index + 1}`];
          })
        ),
      ];
      
      this.setInputAvailability(optionInputs, availableOptionValues, index);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions, optionIndex) {
    listOfOptions.forEach((input) => {
      // Use DOM value property so HTML entities (e.g., &quot;) are decoded to actual characters
      const inputValue = input.value || input.getAttribute('value');
      const optionExists = listOfAvailableOptions.includes(inputValue);
      
      if (optionExists) {
        // Option exists - check if it's available (not sold out)
        const matchingVariants = this.variantData.filter(variant => {
          // Create a complete option set with this option value
          const selectedOptions = this.getSelectedOptions();
          selectedOptions[optionIndex] = inputValue;
          
          return variant.options.every((option, index) => {
            return selectedOptions[index] === option;
          });
        });
        
        const hasAvailableVariant = matchingVariants.some(variant => variant.available);
        
        if (hasAvailableVariant) {
          // Variant is available
          input.innerText = inputValue;
          input.disabled = false;
        } else {
          // Variant exists but is sold out
          input.innerText = `${inputValue} - ${window.variantStrings.soldOut}`;
          input.disabled = false; // Allow selection of sold-out variants
        }
      } else {
        // Option doesn't exist
        input.disabled = true;
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', inputValue);
      }
    });
  }

  getOptionIndex(input) {
    const fieldset = input.closest('fieldset');
    const allFieldsets = [...this.querySelectorAll('fieldset')];
    return allFieldsets.indexOf(fieldset);
  }

  getSelectedOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    return fieldsets.map((fieldset) => {
      const checkedInput = fieldset.querySelector('input:checked');
      return checkedInput ? checkedInput.value : null;
    });
  }
}

customElements.define('main-product-options', MainProductOptions);